import "core-js/modules/es6.reflect.construct";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/toolbar/toolbarseparatorview
 */

import View from "../view";

/**
 * The toolbar separator view class.
 *
 * @extends module:ui/view~View
 */
var ToolbarSeparatorView = /*#__PURE__*/function (_View) {
  _inherits(ToolbarSeparatorView, _View);
  var _super = _createSuper(ToolbarSeparatorView);
  /**
   * @inheritDoc
   */
  function ToolbarSeparatorView(locale) {
    var _this;
    _classCallCheck(this, ToolbarSeparatorView);
    _this = _super.call(this, locale);
    _this.setTemplate({
      tag: 'span',
      attributes: {
        class: ['ck', 'ck-toolbar__separator']
      }
    });
    return _this;
  }
  return _createClass(ToolbarSeparatorView);
}(View);
export { ToolbarSeparatorView as default };